import { Handle, Position } from 'reactflow';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { STEP_STATUS_CONFIG, STEP_TYPE_LABELS } from '../../constants/workflows';

const WorkflowStepNode = ({ data }) => {
  const { step, state, status } = data;
  const config = STEP_STATUS_CONFIG[status] || STEP_STATUS_CONFIG.PENDING;
  const Icon = config.icon;
  const hasJob = !!state?.jobId;

  return (
    <div
      className={`
        px-4 py-3 min-w-[200px] border-2 font-mono
        ${config.bgColor} ${config.borderColor}
        transition-all hover:brightness-110
        ${hasJob ? 'cursor-pointer' : 'cursor-default'}
      `}
      title={hasJob ? 'Click to view job details' : undefined}
    >
      <Handle type="target" position={Position.Top} className="!bg-gray-500 !border-0" />

      <div className="flex items-center gap-3">
        <Icon
          className={`w-5 h-5 flex-shrink-0 ${config.textColor} ${config.animate ? 'animate-spin' : ''}`}
        />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-white truncate">
            {step.name}
          </div>
          <div className="text-xs text-gray-500 truncate">
            {STEP_TYPE_LABELS[step.type] || step.type}
          </div>
        </div>
      </div>

      {state?.jobId && (
        <div className="mt-2 text-xs text-blue-700 flex items-center gap-1">
          <span>Job: {state.jobId.substring(0, 8)}...</span>
          <ArrowTopRightOnSquareIcon className="w-3 h-3" />
        </div>
      )}

      {state?.error && (
        <div className="mt-2 text-xs text-red-700 truncate" title={state.error}>
          {state.error.substring(0, 50)}...
        </div>
      )}

      {state?.retryCount > 0 && (
        <div className="mt-1 text-xs text-yellow-700">
          Retry {state.retryCount}
        </div>
      )}

      <Handle type="source" position={Position.Bottom} className="!bg-gray-500 !border-0" />
    </div>
  );
};

export default WorkflowStepNode;
